import React from 'react';
import PaymentModal from './PaymentModal';
import vaultPaymentService from '../services/vaultPaymentService';

const VaultPaymentModal = ({ vaultId, ...props }) => (
  <PaymentModal {...props} productId={vaultId} paymentService={vaultPaymentService} />
);

export default VaultPaymentModal;
